"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfiniteScrollCollapsableTable = InfiniteScrollCollapsableTable;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _CollapsableTable = require("../collapsable-table/CollapsableTable");
var _reactIntersectionObserver = require("react-intersection-observer");
var _Loader = require("../../../elements/loader/Loader");
var _infiniteScrollCollapsableTableModule = _interopRequireDefault(require("./infinite-scroll-collapsable-table.module.scss"));
var _excluded = ["getHasMore", "onLoadMore", "getIsLoading"];
var InfiniteScrollSentry = function InfiniteScrollSentry(_ref) {
  var onLoadMore = _ref.onLoadMore,
    hasMore = _ref.hasMore,
    isLoading = _ref.isLoading;
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      threshold: 0
    }),
    _useInView2 = (0, _slicedToArray2.default)(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  (0, _react.useEffect)(function () {
    if (inView && hasMore && !isLoading) {
      onLoadMore();
    }
  }, [onLoadMore, inView, hasMore, isLoading]);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  });
};
function InfiniteScrollCollapsableTable(_ref2) {
  var getHasMore = _ref2.getHasMore,
    _onLoadMore = _ref2.onLoadMore,
    getIsLoading = _ref2.getIsLoading,
    collapsableTableProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/_react.default.createElement(_CollapsableTable.CollapsableTable, Object.assign({}, collapsableTableProps, {
    getInfiniteScrollSentry: function getInfiniteScrollSentry(sectionIndex) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getIsLoading(sectionIndex) && /*#__PURE__*/_react.default.createElement("div", {
        className: _infiniteScrollCollapsableTableModule.default['infinite-scroll-collapsable-table__loader']
      }, /*#__PURE__*/_react.default.createElement(_Loader.Loader, {
        "data-testid": "infinite-scroll-loader-".concat(sectionIndex)
      })), /*#__PURE__*/_react.default.createElement(InfiniteScrollSentry, {
        hasMore: getHasMore(sectionIndex),
        onLoadMore: function onLoadMore() {
          return _onLoadMore(sectionIndex);
        },
        isLoading: getIsLoading(sectionIndex)
      }));
    }
  }));
}